export default "__VITE_ASSET__61f41626__"